import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import logo from "../../assets/img/manzil-logo.png";
import "./Navbar.css";
import { BsTwitter, BsWhatsapp } from "react-icons/bs";
import { MdCall } from "react-icons/md";
import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiLogoLinkedin,
} from "react-icons/bi";
import { FaFacebookF } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useEffect, useState } from "react";
import NavHoverDropdown from "./NavHoverDropdown";

export default function NavBar() {

  return (
    <>
      <Navbar expand="lg" className="shadow-sm inner-nav sticky-top bg-white">
        <Container fluid>
          <Navbar.Brand href="/">
            <img src={logo} alt="Manzil" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end">
            <Nav.Link href="/">Home</Nav.Link>
            <NavHoverDropdown title={<>
              Services <IoIosArrowDown />
            </>} id="services-dropdown"
            >
              <NavDropdown.Item href="/child-skill-development">Child Skill Development</NavDropdown.Item>
              <NavDropdown.Item href="/occupational-skills">
                Occupational Training
              </NavDropdown.Item>
              <NavDropdown.Item href="/work-based-placement">Work Based Placement</NavDropdown.Item>
              <NavDropdown.Item href="/corporate-training">Corporate Training</NavDropdown.Item>
              <NavDropdown.Item href="/consultancy">Consultancy</NavDropdown.Item>
            </NavHoverDropdown>
            <NavHoverDropdown title={<>
              Technology & Innovation <IoIosArrowDown />
            </>} id="technology-innovation-dropdown"
            >
              <NavDropdown.Item href="/ar-based-training">AR based Training</NavDropdown.Item>
              <NavDropdown.Item href="/artificial-intelligence">
                Artificial Intelligence
              </NavDropdown.Item>
            </NavHoverDropdown>
            <NavHoverDropdown title={<>
              Knowledge Centre <IoIosArrowDown />
            </>} id="knowledge-centre-dropdown"
            >
              <NavDropdown.Item href="/down-syndrome">Down Syndrome</NavDropdown.Item>
              <NavDropdown.Item href="/autism">
                Autism
              </NavDropdown.Item>
              <NavDropdown.Item href="/adhd">ADHD</NavDropdown.Item>
              <NavDropdown.Item href="/developmental-delays">Developmental Delays</NavDropdown.Item>
            </NavHoverDropdown>
            <Nav.Link
              href="/our-story"
              className={({ isActive }) => (isActive ? "active" : "inactive")}>
              Our Story
            </Nav.Link>
            {/* <Nav.Link href="/child-skill-development">
              Child Skills Development
            </Nav.Link>
            <Nav.Link href="/occupational-skills">
              Occupational Skills{" "}
            </Nav.Link>
            <Nav.Link href="/technology-innovation">
              Technology & Innovation
            </Nav.Link>
            <Nav.Link href="/consultancy">Consultancy</Nav.Link> */}
            <Nav.Link
              href="/contact-us"
              className="default-btn default-btn-orange me-0">
              Contact Us
            </Nav.Link>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="ls-bottom fixed-btns fixed-btns-left">
        <ul className="flex-column ps-1">
          <li>
            <a
              href="https://wa.me/+971509817767?text=Hello Manzil"
              className="w-icon"
              target="_blank">
              <BsWhatsapp />
            </a>
          </li>
          {/* <li>
            <a href="tel:97145294037" target="_blank" className="call-btn">
              <MdCall />
            </a>
          </li> */}
          {/* <li>
            <a
              href="https://www.facebook.com/ManzilCentre/?ref=hl"
              target="_blank">
              <FaFacebookF />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/manzil_center/" target="_blank">
              <BiLogoInstagramAlt />
            </a>
          </li>
          <li>
            <a href="https://in.linkedin.com/company/manzil" target="_blank">
              <BiLogoLinkedin />
            </a>
          </li> */}
          {/* <li>
            <a
              href="https://mobile.twitter.com/friendsofmanzil"
              target="_blank">
              <BsTwitter />
            </a>
          </li> */}
        </ul>
      </div>
      {/* <div className="ls-bottom fixed-btns">
        <ul className="flex-column">
          <li>
            <a href="https://wa.me/+971509817767" className="w-icon" target="_blank">
              <BsWhatsapp />
            </a>
          </li>
          <li>
            <a href="tel:97145294037" target="_blank">
              <MdCall />
            </a>
          </li>
        </ul>
      </div> */}
    </>
  );
}
